

export const API_URL = {

  baseURL: (() => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') {
      return 'https://janaushadhi.gov.in:8443/';
    } else if (hostname === 'janaushadhi.gov.in') {
      return 'https://janaushadhi.gov.in:8443/';
    } else {
      return 'https://janaushadhi.gov.in:8443/';
    }
    // return 'http://192.168.3.192:7001/';
    
  })(),


  // Map Api key******************
  //apiKey:"G4QcCPoZ1WfMO3p474CBrcJ-LnZGlztkP5oZa1uU4Jo", //development key
  apiKey:"bAinO-YGGjAks1kaqFk4tugFKrSOdQ2nmpNees1Fve8", //Testing key

  // youtube api key 
  youtubeApiKey : "AIzaSyBPvQoyj6KxovGmyf5RRnAGF5Ufd3TyqKM",
  youtubeChannelID:"UCyC_ZjR9g6or1e3TIFr0sPA",
  youtubePlaylistIDSuccessStroy:"PLLoHTA2bkfmiUbmKDzuCFMzi1rhBoFj4q",

  youtube:{
     LatestYoutubevideo:"https://www.googleapis.com/youtube/v3/search",
     successStory:"https://www.googleapis.com/youtube/v3/playlistItems"
  },

  userAuth: {
    login: "auth/login",
    adminLogin: "auth/adminLogin",
    getAllRoles : "/api/v1/admin/getAllRoles",
    generateCapatch: "auth/generateCaptcha",
    registration: "auth/register",
    otpGenerate: "auth/generateOtp",
    reSendOtp: "auth/resendOtp",
    verifyOtp: "auth/verifyOtp",
    resetPassword: "auth/resetPassword",
    generateToken: "/auth/generateGuestToken",
    changeUserProfile: "/auth/changeUserProfile",
    checkSessionApi:"/api/kendra/getAllWarehouse"
  },
  applyKendra: {
    basicDetails: "api/kendra/add",
    state: "api/kendra/getAllStateOfIndia",
    district: "/api/kendra/getDistrictByStateId",
    districtByStateId: "/api/kendra/getDistrictByStateId",
    block: "api/kendra/getAllBlockByDistrictId",
    drugLicence: `api/kendra/createDrugLicenseDetails`,
    generatePdf: `api/kendra/generatePdfFile`,
    statebyAdminId: `api/v1/admin/kendra/getAdminStateByAdminId`,
    generateInitialPdf: `/api/kendra/initialLetterDownload`,
    generateFinalPdf: `api/kendra/finalApprovalLetter`,
    uploadAgreement: `api/kendra/uploadDrugAgrrement`,
    notification: `api/kendra/webNotification/getNotificationByUserId`,
    notificationSeen: `api/kendra/webNotification/seenNotification`,
    updatedscletter: '/api/kendra/updateDscLatter',
    applicationgetbyID: '/api/kendra/getKendraDetailsByApplicationId',
    adminById:'/api/v1/admin/getAdminById'
  },
  userStatus: {
    userStatus: `api/v1/admin/kendra/getApplicationById`,
  },
  initialLetter: {
    chequeNumber: `api/kendra/createInitialApprovalLatter`,
  },
  extension: {
    initialLetter: "api/kendra/requestForExtensionOrChangeKendra",
    proposedKendra: "api/kendra/changeProposedKendra",
  },
  aadhar: {
    sendOtp: "api/kendra/aadhaarSendOtp",
    verify: "api/kendra/aadhaarVerify",
  },
  myApplication: {
    byUserId: "api/kendra/getKendraDetailsByUserId",
    byApplicationId: "api/kendra/getKendraDetailsByApplicationId",
    newApplicationId: "api/kendra/getKendraDetailsByApplicationIdNew",
  },
  uploadMultipartFile: "api/kendra/fileupload",
  uploadMultipartMultipleFile: "api/kendra/fileuploadMultiple",
  recuritment: {
    addUpdateJob: "/recruitment/jobController/addUpdateJobPost",
    getListOfJob: "/recruitment/jobController/getAllJob",
    getListOfresume: "/recruitment/getAllResume",
    applyjob: "recruitment/addRecruitmentBasicDetails",
    getJobById: "recruitment/jobController/getById",
    getResumeById: "/recruitment/getResumeById",
    getListOfJobWebSite: "/recruitment/jobController/getJobByMonth",
    getMonthYearList: "/recruitment/jobController/getJobByMonthYears",
    deleteRecruitmentList: "/recruitment/jobController/deleteJobById",
    deleteResumeList: "/recruitment/deleteResumeById",
    getDeleteListOfJobWebSite: '/recruitment/jobController/getAllDeletedJob'
  },
  pmbiUser: {
    districtByStateCode: "/api/kendra/getDistrictByStateCode",
    changepassword: "/auth/ChangePassword",
    addUpdateUser: "/api/v1/admin/addAdmin",
    getrole: "/api/v1/admin/getAllRoles",
    getAllAdminUser: "/api/v1/admin/getAllAdmin",
    getAllKendra: "/api/v1/admin/kendra/getAllKendraDetailsByAdminId",
    getAdminDashboardData:"/api/kendra/superAdminNewDashboard",
    getAllKendrawithsubCategory: "/api/v1/admin/kendra/getAllKendraDetailsByCategoryAdmin",
    getAllKendraSuperAdmin: "/api/v1/admin/kendra/getAllKendraDetailsBySuperAdmin",
    changeStatus: "/api/v1/admin/adminStatusActiveDeactive",
    applicationApproval: "api/v1/admin/kendra/adminKendraUpdate",
    applicationRejection: "api/v1/admin/kendra/applicationRejectByL4AndSuperAdmin",
    exportsApplication: "/api/v1/admin/kendra/exportAllKendraDetailsByAdmin",
    misReport: "api/v1/admin/kendra/micReportGenerateByAdmin",
    changeprofile: "/api/v1/admin/adminChangeProfile",
    getadminprofile: "/api/v1/admin/getAdminById",
  },
  tender: {
    getTenderList: "/api/v1/admin/tender/getAllTender",
    getDebarrdedTenderList: "/api/v1/admin/tender/getAllDebarredList",
    getBlackTenderList: "/api/v1/admin/tender/getAllBlackList",
    getAwardedTenderList: "/api/v1/admin/tender/getAllAwardedTender",
    getRevocationTenderList: "/api/v1/admin/tender/getAllRevocationOrder",
    addTender: "/api/v1/admin/tender/addTender",
    addDebarrded: "/api/v1/admin/tender/addDebarredList",
    addRevocation: "/api/v1/admin/tender/addRevocationOrder",
    addBlackList: "/api/v1/admin/tender/addBlackList",
    addAwardedList: "/api/v1/admin/tender/addAwardedTender",
    updateAwardedList: "/api/v1/admin/tender/updateAwardedTender",
    updateTender: "/api/v1/admin/tender/updateTender",
    changeStatus: "/api/v1/admin/tender/tenderStatusUpdate",
    addviaCsvRevocation: "/api/v1/admin/tender/uploadCsvForRevocationOrder",
    addviaCsvDebarrded: "/api/v1/admin/tender/uploadCsvForDebarredList",
    addviaCsvBlackList: "/api/v1/admin/tender/uploadCsvForBlackList",
    deleteTenderList: "/api/v1/admin/tender",
  },
  debarred: {
    getDebarredList: "/api/v1/admin/tender/getAllDebarredList",
  },
  awarded: {
    getAwardedList: "/api/v1/admin/tender/getAllAwardedTender",
    getAllDeleteAwardedList: "/api/v1/admin/tender/getAllDeleteAwardedTender",
  },
  revocation: {
    getRevocationList: "/api/v1/admin/tender/getAllRevocationOrder",
    getAllDeleteRevocationList: "/api/v1/admin/tender/getAllDeleteRevocationOrder",
  },
  blacklist: {
    getBlackList: "/api/v1/admin/tender/getAllBlackList",
  },
  pharmacist: {
    pharmacistRegister: "/auth/registerPharmacist",
    allPharmacist: "/auth/getAllPharmacist",
    getAllPharmaCist: "/api/v1/admin/getAllPharmacist",
    PharmacistListPdfDownload: "api/v1/admin/pdf/pharmacistPdfDownload",
  },
  payment: {
    paymentStatus: "/api/paymentGetWay/razorPay/getPaymentDetailsByOrderId",
    orderId: "/api/paymentGetWay/razorPay/createOrderId",
    paymentSlip: "api/paymentGetWay/receipt/paymentReceipt",
  },
  dashboard: {
    count: "/api/v1/admin/kendra/getAdminDashboardAppCount",
  },
  distributor: {
    getdistributorList: "/api/v1/admin/distributor/getAllDistributor",
    count: "/api/v1/admin/kendra/getAdminDashboardAppCount",
    getAllDistributor: "/api/v1/admin/distributor/getAllDistributorByStateAndDistrict"
  },
  product: {
    getProductList: "/api/v1/admin/product/getAllProduct",
    searchProduct: "/api/v1/admin/product/searchProducts",
    addProduct: "/api/v1/admin/product/addProduct",
    addviaCSV: "/api/v1/admin/product/uploadCsvFileToDataBase",
    changeStatus: "/api/v1/admin/product/updateProductStatus",
    deleteproduct: "/api/v1/admin/product/softDeleteProduct",
    bulkdeleteproduct: "/api/v1/admin/product/softDeleteProducts",
    porductlist: "/api/v1/admin/product/getAllProduct",
    porductportfoliolist: "/api/v1/admin/product/getAllProductForWeb",
    downloadpdf: "api/v1/admin/pdf/productPdfDownload",
  },
  contact: {
    addContact: "/api/v1/admin/contact/addContact",
    changeStatus: "/api/v1/admin/contact/contactStatusUpdate",
    contactList: "/api/v1/admin/contact/getAllContactByDepartment",
    contactListAdmin: "/api/v1/admin/contact/getAllContact",
    bulkDeleteContact: "/api/v1/admin/contact/softDeleteContacts",
  },
  Governance: {
    getGoverningCouncil: "/api/v1/admin/Governance/getAllGoverningCouncil",
    getAllExecutiveCouncil: "/api/v1/admin/Governance/getAllExecutiveCouncil",
    getManagmentTeam: "/api/v1/admin/Governance/getAllManagementTeam",
  },
  locator: {
    addviaFile: "/api/v1/admin/distributor/uploadCsvFileToDataBase",
    addLocator: "/api/v1/admin/distributor/addDistributor",
    getlocatorList: "/api/v1/admin/distributor/getAllDistributor",
    changestatus: "/api/v1/admin/distributor/distributorStatusUpdate",
    bulkDeleteLocator: "/api/v1/admin/distributor/bulkDeleteDistributer"
  },
  kendra: {
    getkendraList: "/api/v1/admin/addKendra/getAllKendra",
    getKendraCount : '/api/v1/admin/addKendra/countKendra',
    kendraPDF : 'api/v1/admin/pdf/KendraPdfDownload',
    changestatus: "/api/v1/admin/addKendra/kendraStatusUpdate",
    bulkkendradelete: "/api/v1/admin/addKendra/softDeleteKendras",
    addkendra: "/api/v1/admin/addKendra/addKendra",
    addviaCsv: "/api/v1/admin/addKendra/uploadKendraCsvFileToDataBase",
    getkendraListWeb: "/api/v1/admin/addKendra/getAllKendraByStateDistrict",
    getAllNearByKendra: "/api/v1/admin/addKendra/getNearByKendra",
    getAllPacsRegistrationNumber:"/api/kendra/sectorStateCoopFullDetails",
  },
  banner: {
    addbanner: "/api/v1/admin/banner/addBanner",
    getbanner: "/api/v1/admin/banner/getAllBanner",
    changeStatus: "/api/v1/admin/banner/updateBannerStatus",
  },
  image: {
    addimage: "/api/v1/admin/uploadImage/addImage",
    getimage: "/api/v1/admin/uploadImage/getAllImage",
    deleteimage: "/api/v1/admin/uploadImage/deleteImage",
  },
  media: {
    getAllMediaEvent: "/api/v1/admin/media/getAllMediaEventByMonthAndYear",
  },
  hospitallist: {
    getAllHospital: "/api/v1/admin/hospital/getAllHospital",
  },
  annualAndFinancialReport: {
    getAnnualReport: "/api/v1/admin/annualAndFinancial/getAllReportByType",
  },
  whatsNewAndNewsletter: {
    getWhatsnewAndNews: "/api/v1/admin/whatsNewAndNewsLatter/getAllByType",
    getWhatsnewAndNewsById: "/api/v1/admin/whatsNewAndNewsLatter/getWhatsNewAndNewsLatterById"
  },
  managament: {
    addManagament: "/api/v1/admin/Governance/addManagementTeam",
    getManagament: "/api/v1/admin/Governance/getAllManagementTeam",
    deleteManagement: "/api/v1/admin/Governance/deleteByManagementId",
    changeImageStatus: "/api/v1/admin/Governance/managementTeamImageActiveDeactiveById"
  },
  news: {
    AddAndUpdate: "/api/v1/admin/whatsNewAndNewsLatter/addWhatsNewAndNewsLatter",
    getNewsList: "/api/v1/admin/whatsNewAndNewsLatter/getAllByType"
  },
  reports: {
    getReports: '/api/v1/admin/annualAndFinancial/getAllReportByType',
    addReports: '/api/v1/admin/annualAndFinancial/addAnnualAndFinancialReport',
  },
  kendraAndVisterCount: {
    visiterAndKendraCount: "/api/kendra/visitedUserCount"
  },
  Archive: {
    getAllDeleteTenderList: "/api/v1/admin/tender/getAllDeleteTender",
    getAllDeleteDebarredList: "/api/v1/admin/tender/getAllDeleteDebarredList",
    getAllDeleteBlackList: "/api/v1/admin/tender/getAllDeleteBlackList",
    getAllDeleteReportByType: "/api/v1/admin/annualAndFinancial/getAllDeleteReportByType",
  },
  Gallery: {
    getAllDeleteImageList: "/api/v1/admin/uploadImage/getAllDeleteImage",
    getAllDeleteImageArchive:"/api/v1/admin/media/getAllDeleteEventGallery"
  },
  event: {
    addEventInCalander: '/api/v1/admin/media/addEventCalender',
    addEventInGallery: '/api/v1/admin/media/addEventGallery',
    getEventCalander: '/api/v1/admin/media/getAllMediaEventByMonthAndYear',
    getEventGallery: '/api/v1/admin/media/getAllEventGallery',
  }
};

